query GetInvestmentPoolPerformances {
  investmentPoolPerformances {
    id
    pool {
      id
      name
      currency
      legalEntity {
        id
        name
      }
      isActive
    }
    period {
      id
      name
      openingDate
      lockedDate
    }
    openingBalance
    totalReturnForPeriod
    dividendAndInterest
    closingBalance
    returnForPeriod
    weightedContributionsTotal
    weightedGrantsTotal
    weightedTotal
    closingBalanceOfAccountPerformances
    changeInMarketValue
    fees
    floatDelta
  }
}
